import React from 'react';

// Progress indicator component for form completion
const ProgressIndicator = ({ progress, label = "פרטים אישיים" }) => (
  <div className="mb-8">
    <div className="flex justify-between mb-2">
      <span className="text-sm text-indigo-600 font-medium">{progress}% הושלם</span>
      <span className="text-sm text-gray-500">{label}</span>
    </div>
    <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
      <div 
        className="h-full bg-gradient-to-r from-indigo-500 to-purple-600 transition-all duration-500 ease-out"
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  </div>
);

export default ProgressIndicator;